// extracted by mini-css-extract-plugin
export default {"dragHandle":"styles_dragHandle__FEBhR","activeToggle":"styles_activeToggle__fUWP5"};